'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { RhineBrand, RhineSignature } from '@/lib/RhineBrand';
import styles from '@/styles/Auth.module.css';

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  // 系统是否已初始化(是否存在用户);未初始化时引导创建管理员
  const [bootstrap, setBootstrap] = useState(false);

  useEffect(() => {
    fetch('/api/auth/status')
      .then((r) => r.json())
      .then((d) => setBootstrap(!d?.hasAnyUser))
      .catch(() => {});
    // 已登录则直接回首页(会话有效时)
    fetch('/api/auth/me')
      .then((r) => (r.ok ? r.json() : { user: null }))
      .then((d) => {
        if (d.user) {
          router.push('/');
        }
      })
      .catch(() => {});
  }, [router]);

  const handleSubmit = async (ev: React.FormEvent) => {
    ev.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error ?? '登录失败,请稍后重试');
        return;
      }
      router.push('/');
      router.refresh();
    } catch {
      setError('网络错误,请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <RhineBrand />
        <div className={styles.brand}>
          <h1 className={styles.brandTitle}>Sign In</h1>
          <p className={styles.brandSubtitle}>登录 / 欢迎回来</p>
        </div>

        {bootstrap ? (
          <div className={styles.card}>
            <p className={styles.switch}>
              系统尚未初始化,尚无可用账号。请先创建管理员账号后再登录。
            </p>
            <Link className={styles.submitBtn} href="/register">
              创建管理员账号
            </Link>
          </div>
        ) : (
          <form className={styles.card} onSubmit={handleSubmit}>
            <label className={styles.field}>
              <span className={styles.fieldLabel}>用户名</span>
              <input
                className={styles.input}
                value={username}
                onChange={(ev) => setUsername(ev.target.value)}
                placeholder="你的用户名"
                autoComplete="username"
                required
              />
            </label>

            <label className={styles.field}>
              <span className={styles.fieldLabel}>密码</span>
              <input
                className={styles.input}
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
                placeholder="你的密码"
                autoComplete="current-password"
                required
              />
            </label>

            {error && <p className={styles.error}>{error}</p>}

            <button className={styles.submitBtn} type="submit" disabled={submitting}>
              {submitting ? '登录中…' : '登录'}
            </button>
          </form>
        )}
      </main>
      <RhineSignature />
    </>
  );
}
